import type { CountryIso, CountryKey } from "~/types";

export default async function getEligibleNationalities(country: CountryKey): Promise<CountryIso[] | undefined> {
  switch (country) {
    case 'usa': return (await import('../assets/eligibility/usa')).default;
    case 'canada': return (await import('../assets/eligibility/canada')).default;
    case 'morocco': return (await import('../assets/eligibility/morocco')).default;
    case 'korea': return (await import('../assets/eligibility/korea')).default;
    case 'saudi_arabia': return (await import('../assets/eligibility/saudi-arabia')).default;
    case 'bahrain': return (await import('../assets/eligibility/bahrain')).default;
    case 'indonesia': return (await import('../assets/eligibility/indonesia')).default;
    case 'uk': return (await import('../assets/eligibility/uk')).default;
    case 'israel': return (await import('../assets/eligibility/israel')).default;
  }
}